// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-8bad3b1a]{height:42px;width:220px}@media screen and (min-width:600px){.logo[data-v-8bad3b1a]{width:270px}}@media screen and (min-width:1904px){.logo[data-v-8bad3b1a]{width:328px}}", ""]);
// Exports
module.exports = exports;
